import * as React from 'react';
import { memo } from 'react';

import styled from 'styled-components';
import { Link } from 'react-router-dom';

import fontService, { FontWeight } from 'services/FontService';
import { Colors } from 'context';

export interface IMenuItem extends IMenuItemStyle {
  children: string;
  to: string;
  subMenuCount?: number;
  onMenuItemClick?: () => void;
}

export interface IMenuItemStyle {
  isActive?: boolean;
  disabled?: boolean;
}

export const MenuItem = memo(
  ({ to, children, subMenuCount, isActive, disabled, onMenuItemClick }: IMenuItem) => (
    <StyledMenuItem isActive={isActive} disabled={disabled} onClick={onMenuItemClick}>
      <StyledLink to={to}>
        {children}
        {!Number.isNaN(Number(subMenuCount)) && <CountIndicator>{subMenuCount}</CountIndicator>}
      </StyledLink>
    </StyledMenuItem>
  ),
);

const StyledLink = styled(Link)`
  box-sizing: border-box;
  padding: 0px;
  ${fontService.text({ size: 18, lineHeight: 133, weight: FontWeight.medium })}
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: ${Colors.black};
`;

const CountIndicator = styled.sup<IMenuItemStyle>`
  ${fontService.text({ size: 11, lineHeight: 145, weight: FontWeight.regular })}
  margin: 0px 0px 8px 4px;
`;

const StyledMenuItem = styled.li<IMenuItemStyle>`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 1;

  & > ${StyledLink} {
    /* Активный пункт отмечается ЖИРНЫМ начертанием и жёлтой чертой снизу, а
       НЕ жёлтым текстом. main_dark в светлой теме это #F0C015 — контраст на
       белом 1.71:1 при норме 4.5:1, то есть подпись текущего раздела читалась
       хуже всех остальных. Правило и причина — в context/constants/colors.ts.

       Черта живёт псевдоэлементом, а не рамкой: рамка сдвигала бы текст на
       пиксель при переключении разделов. */
    color: ${Colors.black};
    font-weight: ${({ isActive }) => (isActive ? FontWeight.bold : FontWeight.medium)};
    opacity: ${({ disabled }) => (disabled ? '0.1' : '1')};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    & > ${CountIndicator} {
      /* Счётчик у пункта меню — тот же вторичный текст: Colors.gray на
         белом даёт 2.16:1, число курсов рядом с «Moje kursy» не читалось. */
      color: ${({ isActive }) => (isActive ? Colors.black : Colors.gray_dark)};
      opacity: ${({ disabled }) => (disabled ? '0.1' : '1')};
      pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    }
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -6px;
    height: 3px;
    border-radius: 2px;
    background: ${({ isActive }) => (isActive ? Colors.main : 'transparent')};
  }

  &:not(:last-child) {
    margin-right: 20px;
  }
`;
